import { colors } from 'utils/color';
import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  active?: boolean;
}

export default function UserIcon({ active }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon" clip-path="url(#clip0_1161_933)">
        <path
          id="Vector"
          d="M13 11.3333C11.7167 11.3333 10.6181 10.8764 9.70433 9.96267C8.79033 9.04867 8.33333 7.95 8.33333 6.66667C8.33333 5.38333 8.79033 4.28478 9.70433 3.371C10.6181 2.457 11.7167 2 13 2C14.2833 2 15.3819 2.457 16.2957 3.371C17.2097 4.28478 17.6667 5.38333 17.6667 6.66667C17.6667 7.95 17.2097 9.04867 16.2957 9.96267C15.3819 10.8764 14.2833 11.3333 13 11.3333ZM3 21.4873V18.523C3 17.8701 3.17733 17.2654 3.532 16.709C3.88667 16.1526 4.36067 15.7248 4.954 15.4257C6.27178 14.7797 7.60122 14.2951 8.94233 13.972C10.2834 13.6489 11.636 13.4873 13 13.4873C14.364 13.4873 15.7166 13.6489 17.0577 13.972C18.3988 14.2951 19.7282 14.7797 21.046 15.4257C21.6393 15.7248 22.1133 16.1526 22.468 16.709C22.8227 17.2654 23 17.8701 23 18.523V21.4873H3ZM5 19.4873H21V18.523C21 18.253 20.9218 18.003 20.7653 17.773C20.6089 17.5432 20.3966 17.3557 20.1283 17.2103C18.9794 16.6446 17.8081 16.2159 16.6143 15.9243C15.4203 15.633 14.2156 15.4873 13 15.4873C11.7844 15.4873 10.5797 15.633 9.38567 15.9243C8.19189 16.2159 7.02056 16.6446 5.87167 17.2103C5.60344 17.3557 5.39111 17.5432 5.23467 17.773C5.07822 18.003 5 18.253 5 18.523V19.4873ZM13 9.33333C13.7333 9.33333 14.3611 9.07222 14.8833 8.55C15.4056 8.02778 15.6667 7.4 15.6667 6.66667C15.6667 5.93333 15.4056 5.30556 14.8833 4.78333C14.3611 4.26111 13.7333 4 13 4C12.2667 4 11.6389 4.26111 11.1167 4.78333C10.5944 5.30556 10.3333 5.93333 10.3333 6.66667C10.3333 7.4 10.5944 8.02778 11.1167 8.55C11.6389 9.07222 12.2667 9.33333 13 9.33333Z"
          fill={active ? colors.blue3 : colors.grey2}
        />
      </g>
      <defs>
        <clipPath id="clip0_1161_933">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
